var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "icon-scroll" }, [
    _c(
      "svg",
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "46",
          viewBox: "0 0 32 46"
        }
      },
      [
        _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
          _c("path", {
            staticClass: "icon-scroll__shape",
            attrs: {
              stroke: "#FEFEFE",
              "stroke-width": "2",
              d:
                "M16 1c8.284 0 15 6.707 15 15.004v13.992C31 38.282 24.286 45 16 45 7.716 45 1 38.293 1 29.996V16.004C1 7.718 7.714 1 16 1c8.284 0 15 6.707 15 15.004",
              "stroke-dasharray": "145.83",
              "stroke-dashoffset": "145.83"
            }
          }),
          _c("path", {
            staticClass: "icon-scroll__path",
            attrs: {
              stroke: "#FFF",
              "stroke-linecap": "round",
              "stroke-width": "4",
              d: "M16 13v5.28",
              "stroke-dasharray": "5.30",
              "stroke-dashoffset": "5.30"
            }
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ef544bf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef544bf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/icons/icon-scroll-view.vue
// module id = 473
// module chunks = 33